<template>
<header class="text-center text-white p-2 mb-5 bg-slate-900">
  <div class="text-3xl md:text-5xl  sm:text-6xl font-bold mb-3">Movies2Watch</div>
  <p><i class="fa-solid fa-clapperboard"></i> Generator inspired by list from <a class="text-blue-400"
      href="https://www.taschen.com/pages/en/catalogue/film/all/45445/facts.100_all_time_favorite_movies_of_the_20th_century.htm"
      target="_blank">TASCHEN</a></p>
  <p><i class="fa-solid fa-server"></i> API credits by <a class="text-blue-400"
      href="https://www.themoviedb.org/"
      target="_blank">TMDB</a></p>
  <p><i class="fa-solid fa-person-walking-arrow-right"></i> Author <a class="text-blue-400"
      href="https://www.github.com/ahapov"
      target="_blank">Ahapov</a></p>
</header>
</template>

<script>
export default {
  name: 'Header'
};
</script>

